import type { ReactNode } from 'react'
import { usePage } from '@inertiajs/react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import TimerBar from '../components/tracker/Timer/TimerBar'
import type { SharedProps } from '../types'

// App shell mirroring the old Next.js root layout (Header + main + Footer).
export default function AppLayout({ children }: { children: ReactNode }) {
  const { props } = usePage<SharedProps>()
  const { notice, alert } = props.flash ?? {}

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Header />
      <TimerBar />
      <main className="flex-grow container mx-auto p-4">
        {notice && (
          <div className="mb-4 rounded-md bg-green-50 p-3 text-sm text-green-700">{notice}</div>
        )}
        {alert && <div className="mb-4 rounded-md bg-red-50 p-3 text-sm text-red-700">{alert}</div>}
        {children}
      </main>
      <Footer />
    </div>
  )
}
